import { ColumnsPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterGroupByEnum } from '../../filter/reportFilter.types';

export const ORDER_SALES_REPORT_COLUMNS_KEY = 'os';

export const ORDER_ITEMS_SALES_REPORT_COLUMNS_KEY = 'ois';

export const ordersReportKeysToIgnore = [
  ORDER_SALES_REPORT_COLUMNS_KEY,
  ORDER_ITEMS_SALES_REPORT_COLUMNS_KEY,
];

export const ORDER_SALES_REPORT_COLUMNS_KEYS_BY_GROUP_BY = {
  [FilterGroupByEnum.ORDER]: ORDER_SALES_REPORT_COLUMNS_KEY,
  [FilterGroupByEnum.ORDER_ITEM]: ORDER_ITEMS_SALES_REPORT_COLUMNS_KEY,
};

export const ORDER_SALES_REPORT_LIST_BY_GROUP_BY = {
  [FilterGroupByEnum.ORDER]: ColumnsPreferenceRecognizedLists.REPORT_ORDER_SALES,
  [FilterGroupByEnum.ORDER_ITEM]: ColumnsPreferenceRecognizedLists.REPORT_ORDER_ITEMS_SALES,
};
